function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";

var findMatches = function findMatches(string, searchVal) {
  return string.toLowerCase().includes(searchVal.toLowerCase());
};

var useListbox = function useListbox() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var onSearch = arguments.length > 1 ? arguments[1] : undefined;
  var onClose = arguments.length > 2 ? arguments[2] : undefined;
  var scrollFetch = arguments.length > 3 ? arguments[3] : undefined;

  var _useState = useState(options),
      _useState2 = _slicedToArray(_useState, 2),
      filteredOptions = _useState2[0],
      setFilteredOptions = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isClientFiltered = _useState4[0],
      setIsClientFiltered = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      initialOptionsLength = _useState6[0],
      setInitialOptionsLength = _useState6[1];

  var isGrouped = options.length && options[0].items;
  var flattenedOptions = isGrouped ? options.map(function (option) {
    return option.items;
  }).flat() : options;
  var filteredCount = isGrouped ? filteredOptions.map(function (option) {
    return option.items;
  }).flat().length : filteredOptions.length;
  var isClientsideSearch = initialOptionsLength > 10 && !onSearch && !scrollFetch;
  var isServersideSearch = initialOptionsLength > 10 && !!onSearch;
  var isSearchable = isClientsideSearch || isServersideSearch;
  useEffect(function () {
    if (flattenedOptions.length > 0 && initialOptionsLength === 0) {
      setInitialOptionsLength(flattenedOptions.length);
    }
  }, [flattenedOptions.length, initialOptionsLength]);
  useEffect(function () {
    if (!isClientFiltered) {
      setFilteredOptions(options);
    }
  }, [options, isClientFiltered]);

  var handleSearch = function handleSearch(val) {
    if (isServersideSearch) {
      setIsClientFiltered(false);
      onSearch(val);
    } else if (val === "") {
      setIsClientFiltered(false);
      setFilteredOptions(options);
    } else {
      var filtered = isGrouped ? options.map(function (group) {
        return {
          label: group.label,
          items: group.items.filter(function (option) {
            return findMatches(option.label, val);
          })
        };
      }) : options.filter(function (option) {
        return findMatches(option.label, val);
      });
      setIsClientFiltered(true);
      setFilteredOptions(filtered);
    }
  };

  var resetSearch = function resetSearch() {
    if (isServersideSearch) {
      onSearch("");
    } else {
      setFilteredOptions(options);
    }
  };

  var handleClose = function handleClose() {
    resetSearch();
    onClose();
  };

  return {
    filteredOptions: filteredOptions,
    flattenedOptions: flattenedOptions,
    handleSearch: handleSearch,
    handleClose: handleClose,
    filteredCount: filteredCount,
    isGrouped: isGrouped,
    isSearchable: isSearchable
  };
};

export default useListbox;